<div class="desktop-warning-container">
  <div class="visuals">
    <!-- Phone mockup illustration (SVG or image) -->
    <!-- <img src="../../assets/images/mobile-only.png" alt="Phone Mockup" class="phone-mockup" *ngIf="phoneMockupExists"> -->
    <!-- Fun icon/illustration (SVG or image) -->
    <!-- <img src="assets/images/waving-hand.svg" alt="Waving Hand" class="fun-icon" *ngIf="funIconExists"> -->
  </div>
  <div class="text-content">
    <div class="headline">Designed Just for Mobile</div>
    <div class="subheadline">
      Looks like you're on a desktop. Our site is built exclusively for mobile to give you the best experience.
    </div>
    <div class="cta">
      <span class="emoji">📲</span> Scan the QR code below to open on your phone
    </div>
    <div class="qr-code">
      <!-- Replace with your QR code image asset -->
      <img src="../../assets/images/qr.png" alt="Scan QR code to open on mobile" class="qr-image">
    </div>
  </div>
</div>
